import { render, staticRenderFns } from "./viewTeam.vue?vue&type=template&id=2bb794c4"
import script from "./viewTeam.vue?vue&type=script&lang=js"
export * from "./viewTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports